import { ArrowUpRight } from "lucide-react"
import { motion } from "motion/react"

import { AuthCard, LogoMark } from "@/components/auth-card"
import { AuthLayout } from "@/components/auth-layout"

export function AuthMaintenance() {
  return (
    <AuthLayout>
      <LogoMark />
      <AuthCard>
        <div className="space-y-7">
          <div className="flex items-center gap-2">
            <StatusDot />
            <span className="text-2xs font-semibold uppercase tracking-[0.22em] text-rose-400/80">
              Launching soon
            </span>
          </div>

          <div className="space-y-3">
            <h1 className="text-2xl font-semibold tracking-tight text-foreground">
              Sign-ups are paused
            </h1>
            <p className="text-sm leading-relaxed text-muted-foreground">
              We're putting the final touches on Hivehook. New sign-ups and sign-ins will reopen in a few days.
            </p>
          </div>

          <div className="rounded-lg border border-border/40 bg-foreground/2 px-4 py-3">
            <p className="text-xs leading-relaxed text-muted-foreground">
              Already have a sign-in link in your inbox? It still works. Click it from your email to land on the dashboard.
            </p>
          </div>

          <div className="flex items-center justify-between border-t border-border/40 pt-4 text-2xs uppercase tracking-[0.18em]">
            <span className="text-muted-foreground/50">
              Stay in the loop
            </span>
            <motion.a
              href="https://hivehook.com"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.15, duration: 0.4 }}
              className="group inline-flex items-center gap-1 text-rose-400/80 transition-colors hover:text-rose-300"
            >
              hivehook.com
              <ArrowUpRight className="h-3 w-3 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </motion.a>
          </div>
        </div>
      </AuthCard>
    </AuthLayout>
  )
}

function StatusDot() {
  return (
    <span className="relative inline-flex h-2 w-2">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-rose-500 opacity-60" />
      <span className="relative inline-flex h-2 w-2 rounded-full bg-rose-500" />
    </span>
  )
}
